import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import { Checkbox } from "../../../components/ui/Checkbox";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  deleteProductService,
  getAllProductsService,
  getProductByIdService,
  updateProductService, // أضفت الـ import لهذا الـ service (افترض أنه موجود في redux/services/products_service)
} from "redux/services/products_sevice";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { useNavigate } from "react-router-dom";

const ProductTable = ({
  products,
  selectedProducts,
  onProductSelect,
  onSelectAll,
  onProductEdit,
  onProductView,
  sortConfig,
  onSort,
}) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteProductId, setDeleteProductId] = useState(null);

  const dispatch = useDispatch();

  const [loadingEdit, setLoadingEdit] = useState(false);

  const [editingid, setEditingId] = useState(null);

  const [editingProduct, setEditingProduct] = useState(null);

  const [editValues, setEditValues] = useState({});

  // State جديدة للتصدير

  const [showExportModal, setShowExportModal] = useState(false);

  const [exportProductId, setExportProductId] = useState(null);

  const [fromDate, setFromDate] = useState("");

  const [toDate, setToDate] = useState("");

  // دالة لفتح نافذة التصدير

  const handleExportClick = (productId) => {
    setExportProductId(productId);

    setShowExportModal(true);
  };

  // دالة لتأكيد التصدير (كما طلبت، بدون تغيير)

  const handleExportConfirm = async () => {
    if (!exportProductId || !fromDate || !toDate) {
      toast.error(t("يرجى ملء جميع الحقول") || "يرجى ملء جميع الحقول");

      return;
    }

    try {
      // إنشاء رابط الـ API (استخدمت الرابط الكامل كما ذكرته)

      const url = `https://alwathiq-backend.devoracompany.com/api/v1/export/product-sales?product-id=${exportProductId}&from=${fromDate}&to=${toDate}`;

      // افتح الرابط في نافذة جديدة أو قم بتحميل الملف (افترض أن الـ API يعيد ملفاً)

      window.open(url, "_blank"); // أو استخدم fetch إذا كنت تريد تحميل مباشر

   //   toast.success(t("تم بدء التصدير") || "تم بدء التصدير");

      setShowExportModal(false);

      setExportProductId(null);

      setFromDate("");

      setToDate("");
    } catch (error) {
      toast.error(t("حدث خطأ أثناء التصدير") || "حدث خطأ أثناء التصدير");

      console.error("Export error:", error);
    }
  };

  const handleInlineEdit = async (product) => {
    setEditingId(product.id);
    setLoadingEdit(true);
    await dispatch(getProductByIdService(product.id));
    setLoadingEdit(false);
    navigate("/edit-product");

    /* setEditValues({
      name: product.translations?.ar?.name || "", // اسم المنتج بالإنجليزية (يمكن إضافة AR إذا لزم)
      price: product.price,
      quantity: product.quantity, // الكمية لتعديل المخزون والحالة
      // يمكن إضافة حقول أخرى مثل desc إذا أردت: desc: product.translations?.en?.desc
    });*/
  };

  const handleSaveEdit = async (productId) => {
    try {
      // استدعاء الـ API للتحديث
      const response = await dispatch(
        updateProductService({
          id: productId,
          formData: { ...editValues, _method: "PUT" },
        })
      ).unwrap(); // استخدم unwrap() إذا كان RTK Query، أو .then() إذا كان thunk عادي

      if (response?.status === 200 || response?.status === 201) {
        toast.success(t("تم التحديث بنجاح") || "تم التحديث بنجاح");
        // إعادة جلب البيانات أو تحديث محلي (هنا نعيد الجلب)
        dispatch(getAllProductsService({ page: 1 }));
        setEditingProduct(null);
        setEditValues({});
      } else {
        toast.error(t("فشل في التحديث") || "فشل في التحديث");
      }
    } catch (error) {
      toast.error(t("حدث خطأ أثناء التحديث") || "حدث خطأ أثناء التحديث");
      console.error("Update error:", error);
    }
  };

  const handleCancelEdit = () => {
    setEditingProduct(null);
    setEditValues({});
  };

  const handleInputChange = (field, value) => {
    setEditValues((prev) => ({ ...prev, [field]: value }));
  };

  const getStockStatusBadge = (stock, lowStockThreshold = 10) => {
    if (stock === 0) {
      return (
        <span className="px-4 py-1 text-xs font-medium bg-error text-error-foreground rounded-full">
          {t("outOfStock")}
        </span>
      );
    } else if (stock <= lowStockThreshold) {
      return (
        <span className="px-4 py-1 text-xs font-medium bg-warning text-warning-foreground rounded-full">
          {t("lowStock")}
        </span>
      );
    } else {
      return (
        <span className="px-4 py-1 text-xs font-medium bg-success text-success-foreground rounded-full">
          {t("inStock")}
        </span>
      );
    }
  };

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) {
      return (
        <Icon name="ArrowUpDown" size={14} className="text-muted-foreground" />
      );
    }
    return sortConfig.direction === "asc" ? (
      <Icon name="ArrowUp" size={14} className="text-primary" />
    ) : (
      <Icon name="ArrowDown" size={14} className="text-primary" />
    );
  };

  const renderVariants = (variants) => {
    if (!variants || !variants.length) return "No variants";
    return variants.map((variant) => (
      <div key={variant.id}>
        {variant.values
          .map((value) => value.translations?.ar?.value)
          .join(", ")}
      </div>
    ));
  };

  const handleDeleteConfirm = async () => {
    if (!deleteProductId) return;
    try {
      const response = await dispatch(
        deleteProductService(deleteProductId)
      ).unwrap();
      if (response?.status === 200 || response?.status === 201) {
        toast.success(t("تم الحذف بنجاح") || "تم الحذف بنجاح");
        dispatch(getAllProductsService({ page: 1 }));
        setShowDeleteModal(false);
        setDeleteProductId(null);
      } else {
        toast.error(t("فشل في الحذف") || "فشل في الحذف");
      }
    } catch (error) {
      toast.error(t("حدث خطأ أثناء الحذف") || "حدث خطأ أثناء الحذف");
      console.error("Delete error:", error);
    }
  };

  const handleDeleteClick = (productId) => {
    setDeleteProductId(productId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <div className="md:block overflow-x-auto">
        <table className="w-full text-sm text-gray-700">
          <thead className="bg-green-50 text-green-900 font-semibold">
            <tr>
              <th className="text-center p-4 text-sm font-medium text-foreground">
                {t("product")}
              </th>
              <th
                className="text-center p-4 text-sm font-medium text-foreground cursor-pointer hover:bg-muted transition-micro"
                onClick={() => onSort("category")}
              >
                <div className="flex items-center space-x-2">
                  <span>{t("category")}</span>
                  {getSortIcon("category")}
                </div>
              </th>
              <th
                className="text-center p-4 text-sm font-medium text-foreground cursor-pointer hover:bg-muted transition-micro"
                onClick={() => onSort("price")}
              >
                <div className="flex items-center space-x-2">
                  <span>{t("price")}</span>
                  {getSortIcon("price")}
                </div>
              </th>
              <th className="text-center p-4 text-sm font-medium text-foreground">
                {t("quantity")}
              </th>
              {/*<th className="text-center p-4 text-sm font-medium text-foreground">
                {t("variants")}
              </th>*/}
              <th className="text-center p-4 text-sm font-medium text-foreground">
                {t("status")}
              </th>
              <th className="text-center p-4 text-sm font-medium text-foreground">
                {t("actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product) => (
              <tr
                key={product.id}
                className="border-b border-border hover:bg-muted/50 transition-micro"
              >
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 rounded-md overflow-hidden bg-surface mr-2 ml-2 pr-2 pl-2">
                      <Image
                        src={product?.image_url}
                        alt={product?.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      {" "}
                      {/* للسماح بالتوسع */}
                      {editingProduct === product.id ? (
                        <Input
                          type="text"
                          value={editValues.name || ""}
                          /*  onChange={(e) =>
                            handleInputChange("name", e.target.value)
                          }*/
                          placeholder={
                            t("enterProductName") || "Enter product name"
                          }
                          className="mb-1"
                        />
                      ) : (
                        <button
                        //   onClick={() => onProductView(product)}
                        //  className="font-medium text-foreground hover:text-primary transition-micro text-center block w-full text-left"
                        >
                          {product?.name}
                        </button>
                      )}
                      {editingProduct === product.id ? (
                        <Input
                          type="text"
                          value={editValues.desc || product.description || ""}
                          onChange={(e) =>
                            handleInputChange("desc", e.target.value)
                          }
                          placeholder={
                            t("enterDescription") || "Enter description"
                          }
                          className="text-sm"
                        />
                      ) : (
                        <p className="text-sm text-muted-foreground">
                          {product.description}
                        </p>
                      )}
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <span className="text-sm text-foreground">
                    {product?.category_name}
                  </span>
                </td>
                <td className="p-4">
                  {editingProduct === product.id ? (
                    <Input
                      type="number"
                      value={editValues.price || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "price",
                          parseFloat(e.target.value) || 0
                        )
                      }
                      className="w-20"
                      step="0.01"
                      placeholder="0.00"
                    />
                  ) : (
                    <span className="font-medium text-foreground">
                      {product?.price}
                    </span>
                  )}
                </td>
                <td className="p-4 text-center">
                  {" "}
                  {/* عمود جديد للكمية */}
                  {editingProduct === product.id ? (
                    <Input
                      type="number"
                      value={editValues.quantity || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "quantity",
                          parseInt(e.target.value) || 0
                        )
                      }
                      className="w-16"
                      min="0"
                      placeholder="0"
                    />
                  ) : (
                    <span className="font-medium text-foreground">
                      {product?.stock_count}
                    </span>
                  )}
                </td>
                {/* <td className="p-4 text-center">
                  {renderVariants(product?.variants)}
                </td>*/}
                <td className="p-4 text-center">
                  {getStockStatusBadge(
                    editingProduct === product.id
                      ? editValues.stock_count || 0
                      : product.stock_count
                  )}
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-end space-x-2">
                    {editingProduct === product.id ? (
                      <>
                        <button
                          className="p-1"
                          onClick={() => handleSaveEdit(product.id)}
                          title={t("saveChanges")}
                        >
                          <Icon
                            name="Check"
                            size={16}
                            className="text-success"
                          />
                        </button>

                        <button
                          className="p-1"
                          onClick={handleCancelEdit}
                          title={t("cancelEditing")}
                        >
                          <Icon name="X" size={16} className="text-error" />
                        </button>
                      </>
                    ) : (
                      <>
                        {loadingEdit && editingid == product?.id ? (
                          "جاري تحميل البيانات .."
                        ) : (
                          <button
                            className="p-1 mr-2 ml-2"
                            onClick={() => handleInlineEdit(product)}
                            title={t("quickEdit")}
                          >
                            <Icon name="Edit2" size={16} />
                          </button>
                        )}

                        {/* زر التصدير الجديد */}

                        <button
                          className="p-1"
                          onClick={() => handleExportClick(product.id)}
                          title={t("نصدير معلومات المنتج")}
                        >
                          <Icon
                            name="Download"
                            size={16}
                            className="text-primary"
                          />
                        </button>

                        <button
                          className="p-1 text-error hover:text-error"
                          onClick={() => handleDeleteClick(product.id)}
                          title={t("delete")}
                        >
                          <Icon name="Trash2" size={16} />
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {products.length === 0 && (
        <div className="text-center py-12">
          <Icon
            name="Package"
            size={48}
            className="text-muted-foreground mx-auto mb-4"
          />
          <h3 className="text-lg font-medium text-foreground mb-2">
            {t("noProductsFound")}
          </h3>
          <p className="text-muted-foreground">{t("adjustSearch")}</p>
        </div>
      )}

      {/* Modal للتصدير */}

      {showExportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h3 className="text-lg font-semibold mb-4">
              {t("تصدير مبيعات المنتج") || "تصدير مبيعات المنتج"}
            </h3>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2 ">
                {t("من تاريخ") || "من تاريخ"}
              </label>

              <Input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">
                {t("إلى تاريخ") || "إلى تاريخ"}
              </label>

              <Input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="flex justify-end space-x-2 gap-4">
              <Button onClick={handleExportConfirm}>
                {t("تصدير") || "تصدير"}
              </Button>

              <button
                onClick={() => {
                  setShowExportModal(false);

                  setExportProductId(null);

                  setFromDate("");

                  setToDate("");
                }}
                variant="secondary"
              >
                {t("إلغاء") || "إلغاء"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <DeleteConfirmationModal
          isOpen={showDeleteModal}
          onClose={() => {
            setShowDeleteModal(false);
            setDeleteProductId(null);
          }}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </>
  );
};

export default ProductTable;
